/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';

const productImageSize = 45;

function ProductDashboard({ product = {}, style = {} }) {
  return (
    <View style={[styles.productItem, style]}>
      <Image
        style={styles.productImage}
        width={productImageSize}
        height={productImageSize}
        compressWidth={productImageSize}
        source={product?.image || ''}
        key={Math.random()}
      />
      <View>
        <SociollaText style={[styles.productText, styles.productName]}>
          {product?.name || '-'}
        </SociollaText>
        <SociollaText style={styles.productText}>
          SKU: [{product?.sku || '-'}]
        </SociollaText>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  productItem: { flexDirection: 'row', alignItems: 'center', padding: 15 },
  productImage: {
    width: productImageSize,
    height: productImageSize,
    marginRight: 15,
  },
  productText: { fontSize: 14 },
  productName: { marginBottom: 5 },
});

export default React.memo(ProductDashboard, (prev, next) => prev == next);
